// TypeFieldsTitleField.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './TypeFieldsTitleField.css';

// Icons
import Icon from 'svg/Icon';

/**
 * TypeFieldsTitleField
 * 
 * Displayed as the first field in the type properties list, indicating the title field
 * which is always visible in the database view. 
 *  
 *
 * @returns {ReactNode} - TypeFieldsTitleField component.
 */
const TypeFieldsTitleField = React.memo(() => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- RENDER ----- //

    return (

        <div
          className="type-fields-title-field-container"
        >

            {/* ROW MAIN */}
            <div className="type-fields-title-field-row-main">

                <Icon
                  iconKey="title"
                  width={18}
                  height={18}
                  color={theme.foregroundMuted}
                />

                {/* ROW LABEL */}
                <div
                  className="type-fields-title-field-row-label"
                >
                    <div>Title</div>

                    {/* ROW SUBTEXT */}
                    <div className="type-fields-title-field-row-subtext">
                        (always visible)
                    </div>
                </div>

            </div>

        </div>
    );

});

// Dev Tools
TypeFieldsTitleField.displayName = 'TypeFieldsTitleField';

export default TypeFieldsTitleField;
